import {makeStyles} from "@material-ui/core"

// Theme
import {ModernTheme} from "../../../../../theme/modern/tokens"
import {COARSE, touchTarget} from "../../../../../theme/modern/touchTargets"

export default makeStyles((theme: ModernTheme) => ({
    /**
     * Sits directly under the field, in the same place the suggestion list
     * uses — the two are never shown together, because a line that already
     * holds a whole statement no longer matches anything to suggest.
     */
    bar: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "6px",
        marginTop: 6,
        padding: "6px 8px",
        background: theme.modern.panel2,
        border: `1px solid ${theme.modern.line}`,
        borderRadius: 7,
    },
    label: {
        font: `600 10px/1 ${theme.modern.sans}`,
        letterSpacing: ".1em",
        textTransform: "uppercase",
        color: theme.modern.ink3,
        marginRight: 2,
    },
    chips: {
        display: "flex",
        flexWrap: "wrap",
        gap: "4px",
        flex: 1,
        minWidth: 0,
    },
    chip: {
        cursor: "pointer",
        minWidth: 34,
        padding: "4px 7px",
        border: `1px solid ${theme.modern.line}`,
        borderRadius: 5,
        background: theme.modern.panel,
        color: theme.modern.ink2,
        // lead names are read as symbols, so the mono face keeps aVR and aVL
        // from blurring into each other at this size
        font: `600 11.5px/1 ${theme.modern.mono}`,
        textTransform: "none",

        "&:hover": {borderColor: theme.modern.accent, color: theme.modern.accent},

        [COARSE]: touchTarget({minWidth: 44, padding: "0 10px"}),
    },
    chip__active: {
        background: theme.modern.accent,
        borderColor: theme.modern.accent,
        color: theme.modern.onAccent,

        "&:hover": {color: theme.modern.onAccent},
    },
    done: {
        flex: "none",
        cursor: "pointer",
        border: "none",
        background: "none",
        color: theme.modern.ink3,
        font: `600 10px/1 ${theme.modern.sans}`,
        letterSpacing: ".08em",
        textTransform: "uppercase",
        padding: "5px 6px",

        "&:hover": {color: theme.modern.accent},

        [COARSE]: touchTarget({padding: "0 10px"}),
    },
}))
